// modal-helper.service.ts
import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ModalHelperService {
  constructor(private modalController: ModalController) {}

  async closeAllModals(data?: any, role?: string): Promise<boolean> {
    let topModal = await this.modalController.getTop();
    
    while (topModal) {
      await topModal.dismiss(data, role);
      topModal = await this.modalController.getTop();
    }
    
    return true;
  }
}